module.exports = __webpack_public_path__ + "img/aziende-emt.b7d0eab0.png";